function getCommonReportCols(filterOptions: { currency?: string } = {}) {
  return [
    {
      id: "totalBetCount",
      label: `Bet Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "purchaseBetCount",
      label: `Coin Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "winBetCount",
      label: `Win Bet Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "losingBetCount",
      label: `Lose Bet Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "totalBet",
      label: `Total Bet Price (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "purchaseTotalBet",
      label: `Total Coin Price (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "totalWin",
      label: `Total Win Price (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "grossGamingRevenue",
      label: `GGR (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
      tooltip:
        "Gross Gain Ratio (GGR) calculated based on total bet and total win",
    },
    {
      id: "rtp",
      label: `RTP`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "right",
      tooltip:
        "Return to Player (RTP) calculated based on total bet and total win",
    },
  ];
}

function dailyReportColumns(filterOptions: { currency?: string } = {}) {
  const cols = [
    {
      id: "date",
      label: `Date`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    ...getCommonReportCols(filterOptions),
  ];

  return cols;
}

function transactionReportColumns(filterOptions: { currency?: string } = {}) {
  const cols = [
    {
      id: "actions",
      label: "Action",
    },
    {
      id: "date",
      label: `Date`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "roundId",
      label: `Round ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "betTxnId",
      label: `Internal Bet Txn ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "platformTransactionId",
      label: `External Bet Ticket ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "betAmount",
      label: `Bet Amount (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "winAmount",
      label: `Win Amount (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "resolved",
      label: `Bet Status`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "status",
      label: `Status`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "marketType",
      label: `Market`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "transactionType",
      label: `Txn. Type`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "gameBeUserId",
      label: `Game-BE User Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "playerName",
      label: `Player Name`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "user",
      label: `RGS User Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "externalPlayerId",
      label: `External User Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "rtp",
      label: `RTP`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "right",
      tooltip:
        "Return to Player (RTP) calculated based on total bet and total win",
    },
  ];
  return cols;
}

function marketReportColumns(filterOptions: { currency?: string } = {}) {
  const cols = [
    {
      id: "marketType",
      label: `Market Type`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "totalBetCount",
      label: `Bet Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "winBetCount",
      label: `Win Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "losingBetCount",
      label: `Lose Count`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "totalBet",
      label: `Total Bet (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "totalWin",
      label: `Total Win (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "grossGamingRevenue",
      label: `GGR (${filterOptions?.currency})`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
      tooltip:
        "Gross Gain Ratio (GGR) calculated based on total bet and total win",
    },
    {
      id: "rtp",
      label: `RTP`,
      type: "number",
      isSortable: true,
      alignHead: "center",
      alignBody: "right",
      tooltip:
        "Return to Player (RTP) calculated based on total bet and total win",
    },
  ];

  return cols;
}

function playerReportColumns(filterOptions: { currency?: string } = {}) {
  const cols = [
    {
      id: "earliestDate",
      label: `Date`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "externalPlayerId",
      label: `External Player ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "user",
      label: `Internal Player ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    ...getCommonReportCols(filterOptions),
  ];

  return cols;
}

const commonCoionCols = [
  // {
  //   id: "totalCoins",
  //   label: `Total Coins`,
  //   type: "number",
  //   isSortable: true,
  //   alignHead: "center",
  //   alignBody: "center",
  // },
  // {
  //   id: "totalCoinsAvailable",
  //   label: `Available Coins`,
  //   type: "number",
  //   isSortable: true,
  //   alignHead: "center",
  //   alignBody: "center",
  // },
  {
    id: "totalCoinsUtilized",
    label: `Total Utilized Coins`,
    type: "number",
    isSortable: true,
    alignHead: "center",
    alignBody: "center",
    tooltip: "Coins used in store to Buy packs.",
  },
  {
    id: "totalCoinsPurchased",
    label: `Total Purchs. Coins`,
    type: "number",
    isSortable: true,
    alignHead: "center",
    alignBody: "center",
    tooltip: "Coins purchased from store using really currency",
  },
  {
    id: "totalCoinsReceived",
    label: `Total Rcvd. Coins`,
    type: "number",
    isSortable: true,
    alignHead: "center",
    alignBody: "center",
    tooltip:
      "Coins received in form of rewards. For ex: After completing a milestone or selling players.",
  },
];

function dailyCoinReportColumns(filterOptions = {}) {
  const cols = [
    {
      id: "date",
      label: `Date`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    ...commonCoionCols,
  ];
  return cols;
}

function playerCoinReportColumns(filterOptions = {}) {
  const cols = [
    {
      id: "date",
      label: `Date`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "playerId",
      label: `Game BE Player Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "rgsPlayerId",
      label: `Internal Player Id`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    ...commonCoionCols,
  ];

  return cols;
}

export {
  dailyReportColumns,
  playerReportColumns,
  transactionReportColumns,
  marketReportColumns,
  dailyCoinReportColumns,
  playerCoinReportColumns,
};
